import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../index';

const selectState = (state: AppState) => state.weightSync;

export const selectWeightSyncStatuses = createSelector(selectState, ({ sync, isLoading, error }) => {
  return { sync, isLoading, error };
});
export const selectWeightSyncRequestCount = createSelector(selectState, ({ _requestCount }) => {
  return _requestCount;
});
